import React, {Component} from 'react';
import './Leavehistory.css';
import axios from 'axios';
import moment from 'moment'
import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Link } from 'react-router-dom';
class  Leavehistory extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           
            list:[],
            modal:false,
            details:[],
            
          };
    }

  

    async componentDidMount(){
       
        const USR_TOKEN = localStorage.getItem("userToken")
            axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Leave Application?fields=["name","from_date","status","total_leave_days","to_date","leave_type"]'), {
                headers : {'Authorization' : USR_TOKEN, 
            'content-type': 'application/json'}
            })
            .then(response=>{
                //alert('ok')
                    this.setState({list:response.data.data})
                    //this.setState({earn:response.data.data.earnings})
                   // console.log(response.data.data)
                   //this.fetchData(response.data.data[0].name)
    
            })
            .catch(err=>{
                //window.location.href = "/";
                //this.setState({name:response.data['data'][0]})
                //console.log("done")
            })

    }
    modalOpen(data){
        this.setState({ modal: true });
        const USR_TOKEN = localStorage.getItem("userToken")
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Leave Application/'+data), {
            headers : {'Authorization' : USR_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
            //alert('ok')
                this.setState({details:response.data.data})
                //this.setState({earn:response.data.data.earnings})
               // console.log(response.data.data)
               //this.fetchData(response.data.data[0].name)

        })
        .catch(err=>{
            //window.location.href = "/";
            //this.setState({name:response.data['data'][0]})
            console.log(err)
        })
       
    }

  render() {
      
        return <div className="mt-5">
            <h5 className="mb-3">Employee Leave History</h5>
            <table className="table align-middle mb-0 bg-white leave-tab-layout row-select">
            <thead className="bg-light">
                <tr>
                <th>Sr</th>
                <th className="text-center">Status</th>
                <th className="text-center">From Date</th>
                <th className="text-center">To Date</th>
                <th className="text-center">Leave Type</th>
                <th className="text-center">Total Leave Days</th>
                </tr>
            </thead>
            <tbody>
            { this.state.list.map((item,k)=>{
                
                 return(

                        <tr key={k}  onClick={e => this.modalOpen(item.name)}>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="ms-3">
                                        <p className="fw-bold mb-1">{k+1}</p>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                           
                                    {item.status=="Approved" ?  <span className="fw-bold mb-1 status-card-approved">{item.status}</span>:<span className="fw-bold mb-1 status-card-cancelled">{item.status}</span>}
                            </td>
                            <td className="text-center">
                                <p className="fw-normal mb-1">{moment(item.from_date).format('DD-MMM-YYYY')}</p>
                            </td>
                            <td className="text-center">{moment(item.to_date).format('DD-MMM-YYYY')}</td>
                            <td className="text-center">
                            <p className="fw-normal mb-1">{item.leave_type}</p>
                            </td>
                            <td className="text-center">
                            <p className="fw-normal mb-1">{item.total_leave_days}</p>
                            </td>
                        </tr>                       
                ) })}
                
            </tbody>
</table>

                        <Modal size="sm" toggle={() => this.setState({ modal: false })} isOpen={this.state.modal} show={this.state.modal}>
                                        <a
                                            href="#cancel"
                                            onClick={() => this.setState({ modal: false })}
                                            className="close"
                                        >
                                        <i className="fa fa-close"></i>
                                        </a>
                                            <ModalBody className="mt-5">
                                                <h3 className="text-center">Leave Details</h3>
                                                {this.state.details ?
                                                <div className="col-md-12 pop-select">
                                                <p className="fw-bold pop-font pl-2 pr-2 mt-2 mb-2">Leave Type<span className="float-right pop-list">{this.state.details.leave_type}</span></p>
                                                <p className="fw-bold pop-font pl-2 pr-2 mt-2 mb-2">From Date<span className="float-right pop-list">{moment(this.state.details.from_date).format('DD-MMM-YYYY')}</span></p>
                                                <p className="fw-bold pop-font pl-2 pr-2 mt-2 mb-2">To Date<span className="float-right pop-list">{moment(this.state.details.to_date).format('DD-MMM-YYYY')}</span></p>
                                                <p className="fw-bold pop-font pl-2 pr-2 mt-2 mb-2">Total Leave Days<span className="float-right pop-list">{this.state.details.total_leave_days}</span></p>
                                                <p className="fw-bold pop-font pl-2 pr-2 mt-2 mb-2">Reason{this.state.details.description ? <span className="float-right pop-list">{this.state.details.description}</span>:<span className="float-right pop-list">None</span>}</p>
                                                <p className="fw-bold  pl-2 pr-2 mt-2 mb-2">Status{this.state.details.status =="Approved" ?<span className="float-right pop-list pop-active">{this.state.details.status}</span>:<span className="float-right pop-list pop-cancelled">{this.state.details.status}</span>}</p>
                                                </div> : ''}
                                            </ModalBody>
                          
                                    </Modal>



</div>

}
}
export default Leavehistory;